// 按账号记住页面界面状态（本机浏览器 localStorage）
const keyOf = (name, user) => `ali_ui:${name}:${user || "anon"}`;

export const loadUi = (name, user) => {
  try { return JSON.parse(localStorage.getItem(keyOf(name, user)) || "null"); } catch { return null; }
};

export const saveUi = (name, user, value) => {
  try { localStorage.setItem(keyOf(name, user), JSON.stringify(value)); } catch {}
};
